import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { Grid, Form, Header } from 'semantic-ui-react';
import moment from 'moment';

import { RangeDatePickerField, CheckboxField } from 'Common/SemanticWrapper';
import { PRINT_PRODUCTION_MODAL_FORM_NAME } from 'Common/FormEnum';
import { PrintProductionRecordFieldEnum as Fields } from 'Common/FieldEnum';
import {
  DATE_FORMAT_FOR_UI,
  DATE_FORMAT_WITH_DAY_FOR_UI,
} from 'Common/Constants';
import { rangeDateValidator } from 'Common/FormHelper';
import { ProductionRecordFieldEnum as ProdRecordFields } from 'Common/FieldEnum';

class PrintProductionModalForm extends Component {
  static propTypes = {
    prodRecord: PropTypes.object,
    site: PropTypes.string,
  };

  render() {
    const { prodRecord, site } = this.props;

    return (
      <Form>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Header as="h4">
                {prodRecord[ProdRecordFields.CycleMenuDescription]}
              </Header>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Header as="h4">{site}</Header>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Header as="h4">
                {moment(prodRecord[ProdRecordFields.Date]).format(
                  DATE_FORMAT_WITH_DAY_FOR_UI
                )}
              </Header>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ marginTop: 24 }}>
            <Grid.Column width={8}>
              <RangeDatePickerField
                fromName={Fields.FromDate}
                fromLabel="Start Date"
                toName={Fields.ToDate}
                toLabel="End Date"
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ marginTop: 24 }}>
            <Grid.Column width={8}>
              <Field
                label="Print with only planned numbers"
                name={Fields.UsePlannedNumbers}
                component={CheckboxField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

const validate = (values, props) => {
  const errors = {};
  const rangeErrors = rangeDateValidator(
    values[Fields.FromDate],
    values[Fields.ToDate],
    {
      granularity: 'day',
      fromName: Fields.FromDate,
      toName: Fields.ToDate,
      fromLabel: 'From',
      toLabel: 'To',
      dateFormat: DATE_FORMAT_FOR_UI,
      strict: false,
    }
  );

  return {
    ...errors,
    ...rangeErrors,
  };
};

PrintProductionModalForm = reduxForm({
  form: PRINT_PRODUCTION_MODAL_FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
  validate,
})(PrintProductionModalForm);

export { PrintProductionModalForm };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/PrintProductionModalForm.js